export var EActiveView; // Экран выбора из списка аккаунтов, в которые пользователь входил ранее на устройстве
(function (EActiveView) {
  EActiveView["PhoneAuth"] = "phoneAuth";
  EActiveView["PhoneAuthValidateSms"] = "phoneAuthValidateSms";
  EActiveView["PhoneAuthValidateCall"] = "phoneAuthValidateCall";
  EActiveView["AccountSelect"] = "accountSelect";
  EActiveView["ConfirmSelectedAccount"] = "confirmSelectedAccount";
  EActiveView["AccountSelectError"] = "accountSelectError";
  EActiveView["TokenExpiredError"] = "tokenExpiredError";
  EActiveView["AuthenticationRegistration"] = "authenticationRegistration";
  EActiveView["Agreement"] = "agreement";
  EActiveView["SocialCreate"] = "socialCreate";
  EActiveView["SocialMerge"] = "socialMerge";
  EActiveView["TwoFactorWithPhone"] = "twoFactorWithPhone";
  EActiveView["TwoFactorWithEmail"] = "twoFactorWithEmail";
  EActiveView["TwoFactorPhoneValidateSms"] = "twoFactorPhoneValidateSms";
  EActiveView["TwoFactorPhoneValidateCall"] = "twoFactorPhoneValidateCall";
  EActiveView["TwoFactorAttemptsExhausted"] = "twoFactorAttemptsExhausted";
  EActiveView["Restore"] = "restore";
  EActiveView["ConfirmPhone"] = "confirmPhone";
  EActiveView["EmailSent"] = "emailSent";
  EActiveView["RememberedAccountsSelect"] = "rememberedAccountsSelect";
})(EActiveView || (EActiveView = {}));